import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { AgentTab } from '@/entities/agent'

const searchSchema = z.object({
  tab: z.nativeEnum(AgentTab).optional(),
  simulationId: z.string().optional(),
  view: z.literal('run').optional(),
})

export const Route = createFileRoute('/_app/agents-hub/risk-scoring')({
  validateSearch: (search) => searchSchema.parse(search),
})
